// extracted by mini-css-extract-plugin
export default {"host":"or-uPPWDmhbneX-p3W_dt"};